import axios from "axios";
import { config, config_multipart } from "../../api-helper/api-header-configs";
const baseURL = process.env.REACT_APP_API_URL;

// Add New Project
export const add_project = async (values: any) => {
    // Check if values is FormData (has files) or regular object
    const isFormData = values instanceof FormData;
    const requestConfig = isFormData ? config_multipart : config;
    
    let response = await axios.post(baseURL + "/projects", values, requestConfig);
    return response.data;
}

// List of Projects
export const get_all_projects = async () => {
    let response = await axios.get(baseURL + "/projects");
    return response.data;
}

// Get Single Project
export const get_single_project = async (id: string) => {
    let response = await axios.get(baseURL + `/projects/${id}`);
    return response.data;
}

// Update Project
export const update_project = async (id: string, values: any) => {
    let response = await axios.put(baseURL + `/projects/${id}`, values);
    return response.data;
}

// Delete Project
export const delete_project = async (id: string) => {
    let response = await axios.delete(baseURL + `/projects/${id}`);
    return response.data;
}

// Get All Projects Logs
export const get_all_projects_logs = async () => {
    let response = await axios.get(baseURL + '/all-projects-logs');
    return response.data;
}

// Get Single Project Log
export const get_single_project_log = async (id: number) => {
    let response = await axios.get(baseURL + `/single-project-log/${id}`);
    return response.data;
}

